/**
 * Defines the constants used by the Snackbar module.
 * @file
 * @author DJ Kim <dj@thebrandingfarm.com>
 */
export const VUEX_SNACKBAR_SHOW                         = 'VUEX_SNACKBAR_SHOW'
export const VUEX_SNACKBAR_HIDE                         = 'VUEX_SNACKBAR_HIDE'
export const VUEX_SNACKBAR_AUTO_HIDE                    = 'VUEX_SNACKBAR_AUTO_HIDE'
export const VUEX_SNACKBAR_CLICK_HIDE                   = 'VUEX_SNACKBAR_CLICK_HIDE'

